import React, {ReactNode} from "react";
import {Box, CircularProgress} from "@mui/material";

export function ControlWithProgress({loading, size = 24, children}: {
    loading: boolean,
    size?: number,
    children: ReactNode,
}) {
    return (
        <Box sx={{position: "relative"}}>
            {children}
            {loading && (
                <CircularProgress
                    size={size}
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: "-12px",
                        marginLeft: "-12px",
                    }}
                />
            )}
        </Box>
    );
}
